import fileHttp from "@/http/requests/file"
import Vue from "@/main"

export const replaceAll = (string, from, to) => {
  const stringLength = string.length
  let position = 0
  while (position < stringLength) {
    string = string.replace(from, to)
    position++
  }

  return string
}

export const moneyToFloat = (money) => {
  money = money.toString().replace('R$ ', '')
  money = replaceAll(replaceAll(money, ',', ''), '.', '')

  const unitPosition = money.length - 2
  money = parseFloat([
    money.slice(0, unitPosition),
    '.',
    money.slice(unitPosition)
  ].join(''))

  return money
}

// Converts parameters object to GraphQL query parameters
// For example:
// From: { name: "John Doe", age: 35, activated: true }
// To: (name: "John Doe", age: 35, activated: true)
export const paramsObjToGraphQLParams = (paramsObj) => {
  let graphQLParams = '';
  const keysToRemove = [
    'created_at',
    'updated_at',
    'test_sent_at',
    'sent_at',
    'mailchimp_infos'
  ]

  if(paramsObj) {
    graphQLParams = 
      Object
      .keys(paramsObj)
      .map(key => {
        if (keysToRemove.includes(key))
          return 'remove'

        let param = paramsObj[key];

        if (
          typeof param === 'string' 
          && key !== 'subscriber_segments' 
          && key !== 'newsletter_campaign_segments'
        )
          param = `"${param}"`

        return `${key}: ${param}`
      })
      .join(", ");

    graphQLParams = graphQLParams.replace(/, (remove)/gi, '')

    graphQLParams = `( ${graphQLParams} )`;
  }

  return graphQLParams;
}

export const defineSortFieldDirection = (sortField, incomingSort) => {
  const direction = sortField.includes("_asc") ? "desc" : "asc"
  return `${incomingSort}_${direction}`;
}

export const formatDate = (dateStr) => {
  let date = dateStr
  if (date === null || date === '') {
    return {
      day: '',
      month: '',
      year: '',
      hour: '',
      minute: '',
      second: '',
      full: '',
      date_only: ''
    };
  }

  if (typeof date === 'string' && date.includes(' ')) {
    date = date.replace(/\s/, 'T')
  }

  const d = new Date(date);

  let day = d.getDate();
  let month = d.getMonth() + 1;
  const year = d.getFullYear();
  let hour = d.getHours();
  let minute = d.getMinutes();
  let second = d.getSeconds();

  if (day < 10) { day = `0${day}`; }
  if (month < 10) { month = `0${month}`; }
  if (hour < 10) { hour = `0${hour}`; }
  if (minute < 10) { minute = `0${minute}`; }
  if (second < 10) { second = `0${second}`; }

  return {
      day,
      month,
      year,
      hour,
      minute,
      second,
      full: `${day}/${month}/${year} ${hour}:${minute}:${second}`,
      date_only: `${day}/${month}/${year}`
  };
};

export const encodeToBase64 = content => {
  return btoa(unescape(encodeURIComponent(content)))
}

export const decodeFromBase64 = content => {
  return decodeURIComponent(escape(atob(content)))
}

export const detectAndRemoveFileFromBucket = (oldDelta, refs) => {
  const currrentContent = refs.quill.getContents();
  const diff = currrentContent.diff(oldDelta);

  try {
    diff.ops.map(diffOps => {
      const { insert } = diffOps
      if(insert) {
        const imageUrl = insert.image || insert.audio || insert['uploaded-video']
        
        if(imageUrl){
          const urlArray = imageUrl.split("/");
          const filename = urlArray[urlArray.length - 1]

          fileHttp
          .delete(filename)
          .catch(err => {
            console.error(err)
          })
        }
      }
    });
  } catch (error) {
    console.error(error)
  }
}

export const uploadFile = async evt => {
  try {
    const files = evt.target.files

    if(files.length) {
      const file = files[0]

      // Max upload size: 100MB
      if ((file.size / 1024) > (100 * 1024)) {
        Vue.$vs.notify({
          title: 'Tamanho do Arquivo',
          text: 'O tamanho máximo do arquivo deve ser de 100mb',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
        
        throw new Error('Max upload size exceeded!')
      }

      const result = await fileHttp.upload(file)
      return result.data;
    }
  } catch (err) {
    throw new Error(err)
  }
}